import { render, staticRenderFns } from "./ChatMiddle.vue?vue&type=template&id=af59e984&"
import script from "./ChatMiddle.vue?vue&type=script&lang=js&"
export * from "./ChatMiddle.vue?vue&type=script&lang=js&"
import style0 from "./ChatMiddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports